export default class GridSlider {

    constructor(el) {
        this.el = el;
        this.targets = this.el.querySelectorAll('.image-grid-frame');
        this.currentPage = 0;
        this.nav = el.querySelector('.image-grid-nav');
        this.slides = JSON.parse(this.el.getAttribute('data-image-grid-slides'));
        this.totalPages = Math.ceil(this.slides.length / 4);
        this.interval;
        this.visibleSlides = 4;
        this.setupNav();
        this.start();
    }

    setupNav() {
        this.nav.innerHTML = `
            <div class="image-grid-nav-buttons">
                ${ Array(this.totalPages).fill().map((item, i) => `
                    <span class="image-grid-nav__item${ (i == this.currentPage ? ` image-grid-nav__item--current` : '')}" data-image-nav="${i}"></span>
                `).join(' ')}
            </div>
        `;

        const navItems = this.nav.querySelectorAll('.image-grid-nav__item');
        for (let i = 0; i < navItems.length; i++) {
            navItems[i].addEventListener('click', (e) => {
                if (e.target.classList.contains('image-grid-nav__item--current')) {
                    return;
                }
                const slideIndex = e.target.getAttribute('data-image-nav');
                this.currentPage = slideIndex;
                this.goTo(slideIndex);
                this.reset();
            });
        }
    }

    updateNav() {
        const navItems = this.nav.querySelectorAll('.image-grid-nav__item');
        const currentItem = this.nav.querySelector('.image-grid-nav__item--current');
        if (currentItem) {
            currentItem.classList.remove('image-grid-nav__item--current');
        }
        if (navItems[this.currentPage]) {
            navItems[this.currentPage].classList.add('image-grid-nav__item--current');
        }
    }

    start() {
        this.interval = setInterval(() => {
            if (this.currentPage + 1 >= this.totalPages) {
                this.currentPage = 0;
            } else {
                this.currentPage++;
            }
            this.goTo(this.currentPage);
            this.updateNav();
        }, 4000)
    }

    stop() {
        clearInterval(this.interval);
    }

    reset() {
        this.stop();
        this.start();
    }

    animate(el) {
        el.classList.add('image-grid--animating-out');
        el.classList.add('image-grid--reveal');

        setTimeout((el) => {
            el.classList.remove('image-grid--reveal');
            el.classList.remove('image-grid--animating-out');
            el.classList.add('image-grid--animating');
            setTimeout((el) => el.classList.remove('image-grid--animating'), 2000, el);
        }, 2000, el);
    }

    setBackground(el, url) {
        setTimeout(() => el.style.backgroundImage = `url(${url})`, 500, el, url);
    }

    goTo(slideIndex) {

        let start = (4 * slideIndex) + 1;

        for (let i = 1; i <= this.visibleSlides; i++) {
            if (this.slides[start]) {
                this.setBackground(this.targets[i], (this.slides[start].sizes.large ? this.slides[start].sizes.large.url : this.slides[start].sizes.full.url), start);
                this.animate(this.targets[i]);
                start++;
            }
        }

        this.reset();
        this.updateNav();
        this.count = slideIndex >= this.slides.length ? slideIndex : (this.visibleSlides + 1);
    }

}